var render = function render(){var _vm=this,_c=_vm._self._c;return _c('swiper',{ref:"mySwiper",staticClass:"swiper-container-1",attrs:{"options":_vm.swiperOptions}},[_vm._l((_vm.slides),function(item,index){return _c('swiper-slide',{key:index},[_c('img',{staticClass:"slide-image",attrs:{"src":item.image,"alt":"轮播图"}})])}),_c('div',{staticClass:"swiper-pagination",attrs:{"slot":"pagination"},slot:"pagination"})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }